/* ==========================================================================
   Blog Stories - BB2  →  sections/blog-stories-bb2.liquid
   Category filtering plus the progressive "Load more stories" reveal.

   Everything here is an enhancement over markup that already works: the section
   renders every card server side and a <noscript> block shows the ones past the
   initial count while hiding the two controls that need this file. So the no-JS
   page is the whole archive with no filter, never a truncated one.

   Loaded with `defer`, so the definition may register before or after the
   section markup exists — custom elements upgrade either way, which is also
   what keeps this working when the theme editor re-renders the section.
   ========================================================================== */

(function () {
  'use strict';

  if (customElements.get('blog-stories-bb2')) return;

  function toInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) || parsed < 1 ? fallback : parsed;
  }

  customElements.define(
    'blog-stories-bb2',
    class BlogStoriesBB2 extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-stories-grid]');
        if (!this.grid) return;

        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-stories-card]'));
        this.chips = Array.prototype.slice.call(this.querySelectorAll('[data-stories-chip]'));
        this.more = this.querySelector('[data-stories-more]');
        this.moreCount = this.querySelector('[data-stories-more-count]');
        this.counter = this.querySelector('[data-stories-count]');
        this.empty = this.querySelector('[data-stories-empty]');
        this.chipsWrap = this.querySelector('[data-stories-chips]');
        this.footer = this.querySelector('[data-stories-footer]');

        this.step = toInt(this.dataset.step, 6);
        this.initial = toInt(this.dataset.initial, this.step);
        this.countTemplate = this.dataset.countTemplate || '';

        this.filter = 'all';
        this.shown = this.initial;

        this.bind();
        this.render();
      }

      bind() {
        var self = this;

        this.chips.forEach(function (chip) {
          chip.addEventListener('click', function () {
            self.filter = chip.dataset.storiesChip || 'all';
            self.shown = self.initial;

            self.chips.forEach(function (other) {
              other.setAttribute('aria-pressed', other === chip ? 'true' : 'false');
            });

            self.render();
          });
        });

        if (this.more) {
          this.more.addEventListener('click', function () {
            var firstNewIndex = self.shown;
            self.shown += self.step;
            self.render();

            // The button hides itself once everything is shown, so parking focus
            // on it would strand the keyboard on a display:none element. Moving
            // to the first story that just appeared also announces the new
            // content rather than leaving it to be discovered.
            var revealed = self.matching();
            var target = revealed[firstNewIndex] && revealed[firstNewIndex].querySelector('a[href]');
            if (target) target.focus({ preventScroll: true });
          });
        }
      }

      matching() {
        var filter = this.filter;

        return this.cards.filter(function (card) {
          if (filter === 'all') return true;
          var categories = ' ' + (card.dataset.categories || '') + ' ';
          return categories.indexOf(' ' + filter + ' ') > -1;
        });
      }

      render() {
        var match = this.matching();

        this.cards.forEach(function (card) {
          card.hidden = true;
        });

        match.forEach(function (card, index) {
          card.hidden = index >= this.shown;
        }, this);

        var visible = Math.min(this.shown, match.length);
        var remaining = match.length - visible;

        if (this.empty) this.empty.hidden = match.length > 0;
        if (this.more) this.more.hidden = remaining <= 0;
        if (this.moreCount) this.moreCount.textContent = remaining > 0 ? '(' + remaining + ')' : '';

        if (this.counter) {
          this.counter.textContent = match.length
            ? this.countTemplate.replace('[shown]', visible).replace('[total]', match.length)
            : '';
        }
      }
    }
  );
})();
